import { Value } from '../types/GenericFormTypes';

export const objectToFormValues = (obj: Record<string, Value['value']>) => {
  return Object.entries(obj).map(([k, v]) => ({ id: k, value: v })) as Value[];
};

export const objectFromValues = (values: Value[]) => {
  return values.reduce((acc, val) => {
    acc[val.id] = val.value;
    return acc;
  }, {} as Record<string, Value['value']>);
};
